import React from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Section_4() {
  const navigate = useNavigate();

  const buttons = [
    { text: "Get Started on Your Dream Home!", path: "/Custom-homes" },
    { text: "Get Started on Your Dream Kitchen!", path: "/KitchenDesign" },
    { text: "Get Started on Your Dream Bathroom!", path: "/BathroomDesign" },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "50vh",
        backgroundColor: "black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingY: { xs: 5, sm: 8, md: 10 },
      }}
    >
      {/* Background Overlay Box */}
      <Box
        sx={{
          width: { xs: "95%", sm: "85%", md: "80%" },
          backgroundImage: 'url("/assets/section-4-overlay-image.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 2, sm: 3, md: 5 },
          paddingY: { xs: 4, sm: 6, md: 8 },
          textAlign: "center",
        }}
      >
        {/* Heading */}
        <Typography
          variant="h4"
          sx={{
            background: "linear-gradient(to bottom, #FFFFFF, #404040)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 500,
            fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2vw" },
          }}
        >
          Start The Process Now!
        </Typography>

        <Box
          sx={{
            width: "40%",
            borderBottom: "3px solid green",
          }}
        />

        {/* Paragraph */}
        <Typography
          sx={{
            color: "white",
            fontSize: { xs: "1rem", sm: "1.2rem", md: "1.2vw" },
            fontWeight: 300,
            width: { xs: "90%", sm: "80%", md: "75%" },
          }}
        >
          "Ready to transform your vision into reality? Begin your process now and achieve your dreams with our expert guidance."
        </Typography>

        {/* Buttons */}
        <Grid
          container
          spacing={2}
          justifyContent="center"
          sx={{ width: "90%", marginTop: { xs: 2, sm: 3, md: 4 } }}
        >
          {buttons.map(({ text, path }, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Button
                variant="outlined"
                onClick={() => navigate(path)}
                sx={{
                  width: "100%",
                  fontSize: { xs: "0.9rem", sm: "1rem", md: "1vw" },
                  padding: { xs: "0.5em", sm: "0.8em" },
                  borderRadius: "40px",
                  border: "2px solid green",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "green",
                    color: "black",
                  },
                }}
              >
                {text}
              </Button>
            </Grid>
          ))}
        </Grid>

      </Box>
    </Box>
  );
}
